import { Emphasis } from './Emphasis';

export interface IColors {
    black: string;
    white: string;
    whiteDove: string;
    primary900: string;
    primary800: string;
    primary700: string;
    primary600: string;
    primary500: string;
    primary400: string;
    primary300: string;
    primary200: string;
    primary100: string;
    primary50: string;
    danger: string;
    info: string;
    success: string;
    warning: string;
    unvisitedLink: string;
    visitedLink: string;
    blackHighEmphasis: string;
    blackMediumEmphasis: string;
    blackLightEmphasis: string;
    blackDisabledEmphasis: string;
    whiteHighEmphasis: string;
    whiteMediumEmphasis: string;
    whiteDisabledEmphasis: string;
    redLightEmphasis: string;

    [key: string]: string;
}

export const Colors: IColors = {
    black: '#000000',
    white: '#FFFFFF',
    whiteDove: '#FBFBFB',
    primary900: '#212121',
    primary800: '#424242',
    primary700: '#616161',
    primary600: '#757575',
    primary500: '#9E9E9E',
    primary400: '#BDBDBD',
    primary300: '#E0E0E0',
    primary200: '#EEEEEE',
    primary100: '#F5F5F5',
    primary50: '#FAFAFA',
    danger: '#B00020',
    info: '#54A6D7',
    success: '#70B000',
    warning: '#EE9F57',
    unvisitedLink: '#0000EE',
    visitedLink: '#551A8B',
    blackHighEmphasis: `rgba(0, 0, 0, ${Emphasis.high.value})`,
    blackMediumEmphasis: `rgba(0, 0, 0, ${Emphasis.medium.value})`,
    blackLightEmphasis: `rgba(0, 0, 0, ${Emphasis.light.value})`,
    blackDisabledEmphasis: `rgba(0, 0, 0, ${Emphasis.disabled.value})`,
    blackPaleEmphasis: `rgba(0, 0, 0, ${Emphasis.pale.value})`,
    whiteHighEmphasis: `rgba(255, 255, 255, ${Emphasis.high.value})`,
    whiteMediumEmphasis: `rgba(255, 255, 255, ${Emphasis.medium.value})`,
    whiteDisabledEmphasis: `rgba(255, 255, 255, ${Emphasis.disabled.value})`,
    redLightEmphasis: `rgba(176, 0, 32, ${Emphasis.pale.value})`,
    successEmphasis: `rgba(112, 176, 0, ${Emphasis.pale.value})`,
    warningEmphasis: `rgba(238, 159, 87, ${Emphasis.pale.value})`
};
